import { defineStore } from 'pinia'
import { useBaseStore } from '@haskoning/vue-basestore'
import { useShipAPI } from '@/api/useShipApi'
import SHIP_API from '@/api/shipApiUrls'
import { ref } from 'vue'
import type { ShipAPIType } from '@/stores/type/shipAPI.type'
import { useSelectedItemMixin } from '@/stores/useSelectedItemMixin'

const { api } = useShipAPI()
const baseURL = SHIP_API.SHIPS.INDEX

export const useShipAPIStore = defineStore('shipAPI', () => {
  const baseStore = useBaseStore({ service: baseURL, api })
  const selectedItemMixin = useSelectedItemMixin(baseStore)
  const validationStatus = ref<boolean>(true)

  function resetAll() {
    baseStore.reset()
  }

  const fetchShipItems = async () => {
    const approved: string | null = validationStatus.value ? 'true' : null
    const response = await baseStore.fetchItems({
      has_armour_param: 'true',
      application: 'armour',
      //ARMOUR Application search name in SHIP
      approved: approved
    })
    if (!response) {
      baseStore.items.value = []
      baseStore.currentItem.value = null
    } else if (baseStore.items.value?.length > 0) {
      baseStore.setCurrentItem(baseStore.items.value[0])
    }
  }

  const setValidationStatus = (status: boolean) => {
    validationStatus.value = status
  }

  const getValidationStatus = (item: ShipAPIType) => {
    const shipValidation = item.validation_set.find((validation) => {
      return validation.appsearchname === 'armour'
    })
    return shipValidation ? shipValidation.approved : false
  }

  return {
    ...baseStore,
    ...selectedItemMixin,
    validationStatus,
    setValidationStatus,
    fetchShipItems,
    getValidationStatus,
    resetAll
  }
})
